// extracted by mini-css-extract-plugin
export default {"runningListDiv":"Courses_runningListDiv__zAmdP","courseCard":"Courses_courseCard__4n4Oo","dateDiv":"Courses_dateDiv__Yc8MN","editButton":"Courses_editButton__O1ly6"};